import { render } from "./GravatarSettings.vue?vue&type=template&id=a7b21972"
import script from "./GravatarSettings.vue?vue&type=script&lang=js"
export * from "./GravatarSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__